import React from "react";
import { connect } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import { noImg } from "vrcore-dashboard/dist/utilities";
import styled from "styled-components";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import { Add as AddIcon } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import _ from "lodash";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextareaAutosize from "react-textarea-autosize";
import { Link } from "react-router-dom";
import moment from "moment";
import {
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    Spinner,
    Input,
    Label,
} from "reactstrap";

import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";

import {
    Button,
    Typography,
    withStyles,
    TextField,
    Table,
    TableBody,
    TableHead,
    TableCell,
    TableRow,
    MenuItem,
    Select,
    List,
    ListItem,
    ListItemText,
} from "@material-ui/core";

import {
    setNewFeature,
    getFeatures,
    removeFeature,
    emailFeature,
    editFeature,
    uploadFile,
    uploadFileManager,
} from "./actions";

import {
    selectFeature,
    getRequesting,
    canUpdate,
    canCreate,
    canDelete,
} from "./selectors";

import IconButton from "@material-ui/core/IconButton";

let d = new Date();
var refDate =
    d.getDate() +
    "-" +
    (d.getMonth() + 1) +
    "-" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes();

const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;

const RadioLabel = styled(Label)`
    margin-top: 11px;
    margin-left: -24px;
    margin-right: 10px;
`;

const styles = () => ({
    addUserModel: {
        width: "60%",
    },
    list: {
        width: "100%",
        marginTop: 15,
        marginBottom: 1,
        borderRadius: 5,
        backgroundColor: "#3f51b5",
    },
    listItem: {
        width: "auto",
        backgroundColor: "white",
        marginLeft: 10,
        marginRight: 10,
        borderRadius: 5,
        marginBottom: 1,
        marginTop: 1,
        padding: 0,
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflowX: "auto",
    },
    form: {
        position: "relative",
        width: "90%",
    },
});
class Help extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadImageLocal: false,
            uploadImageLocalMultiple: [],
            page: 0,
            colorNo: 0,
            rowsPerPage: 50,
            removeUID: false,
            editUID: false,
            newFeatureModal: false,
            removeFeatureModal: false,
            viewFeatureModal: false,
            editFeatureModal: false,
            processModel: false,
            new_feature: {
                feature_name: "",
                feature_date: refDate,
                feature_platform: "",
                feature_impacted_page: "",
                feature_priority: "",
                feature_description: "",
                feature_type: "New Report",
                feature_status: "",
                feature_build_number: "",
                feature_jira_number: "",
                feature_image: "",
                feature_comments: "",
                feature_request_details: "",
                feature_resolution_time: "",
                feature_deleted: false,
                feature_other: "",
                feature_requestor_email: "",
                feature_requestor_organization: "",
                attached_photos: [],
                attached_files: [],
            },
        };

        props.getFeatures();
    }

    genRandomNumber(min, max) {
        let random_number = Math.random() * (max - min) + min;
        return Math.floor(random_number);
    }
    renderTextDetail(label, key) {
        const { new_feature } = this.state;
        const { classes } = this.props;

        return (
            <TextField
                key={key}
                value={new_feature[key]}
                label={label}
                className={classes.textField}
                onChange={(val) => {
                    new_feature[key] = val.target.value;
                    this.setState({ new_feature });
                }}
            />
        );
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleNewGroupModal = () => {
        this.setState({
            newFeatureModal: true,
            uploadImageLocalMultiple: [],
            new_feature: {
                feature_name: "",
                feature_date: refDate,
                feature_platform: "",
                feature_impacted_page: "",
                feature_priority: "",
                feature_description: "",
                feature_type: "",
                feature_status: "",
                feature_build_number: "",
                feature_jira_number: "",
                uploadImageLocal: false,
                attached_photos: [],
                feature_image: "",
                feature_deleted: false,
                feature_requestor_name: "",
                feature_comments: "",
                feature_resolution_time: "",
                feature_other: "",
                feature_requestor_email: "",
                feature_requestor_organization: "",
                attached_files: [],
            },
        });
    };

    handleCloseGroupModal = () => {
        this.setState({ uploadImageLocal: false });
        this.setState({ newFeatureModal: false });
        this.setState({ processModal: false });
    };
    handleEditGroupModal = () => {
        this.setState({ editFeatureModal: true });
    };
    handleCloseEditGroupModal = () => {
        this.setState({ editFeatureModal: false });
    };
    handleViewGroupModal = () => {
        this.setState({ viewFeatureModal: true });
        this.setState({ uploadImageLocal: false });
    };
    handleCloseViewGroupModal = () => {
        this.setState({ viewFeatureModal: false });
        this.setState({ uploadImageLocal: false });
    };
    handleRemoveGroupModal = () => {
        this.setState({ removeFeatureModal: true });
    };
    handleCloseRemoveGroupModal = () => {
        this.setState({ removeFeatureModal: false });
    };
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: event.target.value });
    };
    onFormSubmit(feature) {
        this.props.setNewFeature(feature);
        this.handleCloseGroupModal();
        this.setState({ uploadImageLocal: false });
    }
    getInitials(name) {
        if (typeof name === "undefined") return "NA";

        let first = name.split(" ")[0][0];
        let last = name.split(" ")[name.split(" ").length - 1][0];
        return `${first}${last}`;
    }
    renderRequiredGroupDetails = () => {
        return (
            <div>
                <ModalBody>
                    <div
                        style={{
                            marginLeft: 0,
                            position: "absolute",
                            bottom: 0,
                        }}
                    >
                        <br />
                        <Label
                            style={{ color: "#6a7bc4", marginLeft: "-15px" }}
                        >
                            {" "}
                            <b> Add Screenshot If Applicable </b>{" "}
                        </Label>
                    </div>
                </ModalBody>
                <ModalBody>
                    {/* <input
                                type="file"
                                id="file"
                                accept="image/*"
                                ref="imageUploader"
                                style={{ display: "none" }}
                                onChange={(event) => {
                                    if (event.target.files[0] && event.target.files[0].size > 1000000) {
                                        this.setState({ fileMaxSizeSnackbar: true });
                                    } else {
                                        let feature = {
                                            ...this.state.new_feature,
                                            feature_image: event.target.files[0],
                                        };
                                        
                                        this.setState({
                                            new_feature: feature,
                                            uploadImageLocal: URL.createObjectURL(
                                            event.target.files[0]
                                            ),
                                        });
                                        // this.state.setGroupImgBlob(event.target.files[0]);
                                    }
                                }}
                            /> */}

                    <input
                        type="file"
                        id="file"
                        accept="image/*"
                        ref="imageUploader"
                        multiple
                        style={{ display: "none" }}
                        onChange={(event) => {
                            if (
                                event.target.files[0] &&
                                event.target.files[0].size > 1000000
                            ) {
                                this.setState({
                                    fileMaxSizeSnackbar: true,
                                });
                            } else {
                                let local =
                                    this.state.uploadImageLocalMultiple || [];

                                let curr = [];
                                let data = this.state.new_feature;
                                if (event.target.files)
                                    Object.keys(event.target.files).map((f) => {
                                        curr.push(
                                            URL.createObjectURL(
                                                event.target.files[f]
                                            )
                                        );
                                        this.props.uploadFile(
                                            this.state.new_feature.feature_name,
                                            event.target.files[f],
                                            (status) => {
                                                if (status.url) {
                                                    data.attached_photos.push(
                                                        status.url
                                                    );
                                                }
                                            }
                                        );
                                        return null;
                                    });
                                if (
                                    this.state.uploadImageLocalMultiple
                                        .length <= 3 &&
                                    event.target.files.length <= 4
                                )
                                    this.setState({
                                        new_feature: data,
                                        uploadImageLocalMultiple: [
                                            ...local,
                                            ...curr,
                                        ],
                                    });
                            }
                        }}
                    />

                    <div>
                        <ModalRow
                            style={{
                                padding: "5px",
                                border: "1px solid #4CAF50",
                                borderRadius: 5,
                            }}
                        >
                            <Col
                                style={{
                                    padding: "8px",
                                    border: "1px solid #4CAF50",
                                    borderRadius: 5,
                                }}
                            >
                                <center>
                                    <IconButton
                                        onClick={() => {
                                            this.refs.imageUploader.click();
                                        }}
                                        style={{
                                            margin: "inherit",
                                            color: "green",
                                            border: "1px solid green",
                                            marginTop: "40px",
                                        }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </center>
                                <Typography
                                    style={{ margin: "inherit" }}
                                    variant="body2"
                                >
                                    <center> {"( Max : 4 ) "} </center>
                                    <center> {"( < 1MB )"} </center>
                                </Typography>
                            </Col>

                            {/* <Col style={{padding: "8px",border: "1px solid #4CAF50",borderRadius: 5,marginLeft:"2px"}}>
                            <center>
                                <img
                                    style={{
                                        width: "150px",
                                        height: "150px",
                                    }}
                                    src={
                                        this.state.uploadImageLocal
                                            ? this.state.uploadImageLocal
                                            : noImg
                                    }
                                    alt="Proof"
                                />
                            </center>
                            </Col> */}
                            {this.state.uploadImageLocalMultiple &&
                                this.state.uploadImageLocalMultiple.map((e) => {
                                    return (
                                        <Col
                                            style={{
                                                padding: "3px",
                                                border: "1px solid #4CAF50",
                                                borderRadius: 5,
                                                marginLeft: "2px",
                                            }}
                                        >
                                            <img
                                                style={{
                                                    width: "150px",
                                                    height: "150px",
                                                }}
                                                src={e ? e : noImg}
                                                alt="Proof"
                                            />
                                        </Col>
                                    );
                                })}
                        </ModalRow>
                    </div>
                </ModalBody>
            </div>
        );
    };

    render() {
        const features =
            this.props.features === [] ? false : this.props.features;
        const { new_feature } = this.state;
        const { classes } = this.props;
        var date = new Date();
        var currDate = moment(date).format("YYYY-MM-DDThh:mm");

        return (
            <StyledCard>
                <StyledHeader>
                    <Typography variant="h5">Support</Typography>
                </StyledHeader>
                <StyledContent>
                    <Modal
                        isOpen={this.state.processModal}
                        style={{ maxWidth: "00px" }}
                    >
                        <ModalBody>
                            <div
                                style={{
                                    textAlign: "center",
                                    paddingTop: "3em",
                                }}
                            >
                                <div
                                    style={{
                                        background: "white",
                                        width: "fit-content",
                                        display: "inline-block",
                                        padding: "2em",
                                    }}
                                >
                                    <Spinner
                                        style={{
                                            height: 100,
                                            width: 100,
                                            background: "white",
                                        }}
                                        color="primary"
                                    />
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            marginTop: 15,
                                            color: "rgba(0, 0, 0, 0.87)",
                                            fontWeight: "bolder",
                                            fontSize: 20,
                                        }}
                                        variant="body2"
                                    >
                                        Processing...
                                    </Typography>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    <div className={classes.tableWrapper}>
                        <StyledViewContainer>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        {this.props.canCreate && (
                                            <Button
                                                onClick={() => {
                                                    this.handleNewGroupModal();
                                                }}
                                                color="primary"
                                                variant="contained"
                                            >
                                                Add New Feature
                                            </Button>
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableHead>
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="body2">
                                                <b>Feature ID</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="body2">
                                                <b>Date and Time Of Request</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="body2">
                                                <b>Platform</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="body2">
                                                <b>Impacted Page</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="body2">
                                                <b>Priority</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="body2">
                                                <b>Status</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            <Typography variant="body2">
                                                <b>Action</b>
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {features.map((e, i) => {
                                        if (e.feature_deleted !== true) {
                                            return (
                                                <TableRow key={i}>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                    >
                                                        <Typography variant="body1">
                                                            {e.feature_id}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                    >
                                                        <Typography variant="body1">
                                                            {e.feature_date}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                    >
                                                        <Typography variant="body1">
                                                            {e.feature_platform}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                    >
                                                        <Typography variant="body1">
                                                            {
                                                                e.feature_impacted_page
                                                            }
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                    >
                                                        <Typography variant="body1">
                                                            {e.feature_priority}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                    >
                                                        <Typography variant="body1">
                                                            {e.feature_status}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                    >
                                                        <IconButton
                                                            aria-label="View"
                                                            onClick={() => {
                                                                this.setState({
                                                                    editUID:
                                                                        e.feature_id,
                                                                    new_feature: e,
                                                                });
                                                                this.handleViewGroupModal();
                                                            }}
                                                        >
                                                            <ViewIcon />
                                                        </IconButton>
                                                        {this.props
                                                            .canDelete && (
                                                            <IconButton
                                                                aria-label="Delete"
                                                                onClick={() => {
                                                                    this.setState(
                                                                        {
                                                                            removeUID:
                                                                                e.feature_id,
                                                                        }
                                                                    );
                                                                    this.handleRemoveGroupModal();
                                                                }}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        )}
                                                        {this.props
                                                            .canUpdate && (
                                                            <IconButton
                                                                aria-label="Edit"
                                                                onClick={() => {
                                                                    this.setState(
                                                                        {
                                                                            editUID:
                                                                                e.feature_id,
                                                                            new_feature: e,
                                                                        }
                                                                    );
                                                                    this.handleEditGroupModal();
                                                                }}
                                                            >
                                                                <EditIcon />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        } else return null;
                                    })}
                                </TableBody>
                            </Table>
                        </StyledViewContainer>
                    </div>
                    <div>
                        <Modal
                            isOpen={this.state.viewFeatureModal}
                            className={classes.addUserModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Feature Description
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <div>
                                                <Label for="name">
                                                    Company
                                                    Name&nbsp;:&nbsp;&nbsp;
                                                </Label>
                                                <span
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {" "}
                                                    {
                                                        this.state.new_feature
                                                            .feature_name
                                                    }{" "}
                                                </span>
                                                <br />
                                            </div>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <div>
                                                <Label for="name">
                                                    Date of
                                                    Request&nbsp;:&nbsp;&nbsp;
                                                </Label>
                                                <span
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {
                                                        this.state.new_feature
                                                            .feature_date
                                                    }
                                                </span>
                                                <br />
                                            </div>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <div>
                                                <Label for="name">
                                                    Date of
                                                    Resolution&nbsp;:&nbsp;&nbsp;
                                                </Label>
                                                <span
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {
                                                        this.state.new_feature
                                                            .feature_resolution_time
                                                    }
                                                </span>
                                                <br />
                                            </div>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <div>
                                                <Label for="name">
                                                    Requestor
                                                    Name&nbsp;:&nbsp;&nbsp;
                                                </Label>
                                                <span
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {
                                                        this.state.new_feature
                                                            .feature_requestor_name
                                                    }
                                                </span>
                                                <br />
                                            </div>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <div>
                                                <Label for="name">
                                                    Comments&nbsp;:&nbsp;&nbsp;
                                                </Label>
                                                <span
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {
                                                        this.state.new_feature
                                                            .feature_comments
                                                    }
                                                </span>
                                                <br />
                                            </div>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="platform">
                                                Platform&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {
                                                    this.state.new_feature
                                                        .feature_platform
                                                }
                                            </span>
                                            <br />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="pages">
                                                Impacted Page&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {
                                                    this.state.new_feature
                                                        .feature_impacted_page
                                                }
                                            </span>
                                            <br />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="priority">
                                                Priority&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {
                                                    this.state.new_feature
                                                        .feature_priority
                                                }
                                            </span>
                                            <br />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="type">
                                                Type&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {
                                                    this.state.new_feature
                                                        .feature_type
                                                }
                                            </span>
                                            <br />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="description">
                                                Description&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <p
                                                style={{
                                                    fontWeight: "bold",
                                                    wordBreak: "break-all",
                                                }}
                                            >
                                                {
                                                    this.state.new_feature
                                                        .feature_description
                                                }
                                            </p>
                                            <br />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="status">
                                                Status&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {
                                                    this.state.new_feature
                                                        .feature_status
                                                }
                                            </span>
                                            <br />
                                        </Col>
                                    </ModalRow>
                                    {/* <ModalRow>
                                        <Col>
                                            <Label for="build">
                                                Build Number&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {
                                                    this.state.new_feature
                                                        .feature_build_number
                                                }
                                            </span>
                                            <br />
                                        </Col>
                                    </ModalRow> */}
                                    <ModalRow>
                                        <Col>
                                            <Label for="jira">
                                                Jira Number&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {
                                                    this.state.new_feature
                                                        .feature_jira_number
                                                }
                                            </span>
                                            <br />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="image">
                                                Evidence&nbsp;&nbsp;&nbsp;
                                            </Label>
                                            <br />
                                            {this.state.new_feature
                                                .attached_photos &&
                                                this.state.new_feature.attached_photos.map(
                                                    (e) => {
                                                        return (
                                                            <div
                                                                style={{
                                                                    padding:
                                                                        "8px",
                                                                    marginBottom:
                                                                        "15px",
                                                                    border:
                                                                        "1px solid #4CAF50",
                                                                    borderRadius: 5,
                                                                    marginLeft:
                                                                        "2px",
                                                                }}
                                                            >
                                                                <img
                                                                    style={{
                                                                        width:
                                                                            "400px",
                                                                        height:
                                                                            "297px",
                                                                    }}
                                                                    src={
                                                                        e
                                                                            ? e
                                                                            : noImg
                                                                    }
                                                                    alt="Proof"
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                )}

                                            <img
                                                style={{
                                                    width: "442px",
                                                    height: "297px",
                                                }}
                                                src={
                                                    this.state.new_feature
                                                        .feature_image
                                                        ? this.state.new_feature
                                                              .feature_image
                                                        : ""
                                                }
                                                // onChange={(event) => {
                                                //     let newFeature = this.state
                                                //         .new_feature;
                                                //     newFeature.feature_platform =
                                                //         event.target.value;
                                                //     this.setState({
                                                //         new_feature: newFeature,
                                                //     });
                                                // }}
                                                alt="Featured"
                                            />
                                            <br />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="files">
                                                Attached Files:
                                                &nbsp;&nbsp;&nbsp;
                                            </Label>
                                            {this.state.new_feature
                                                .attached_files && (
                                                <List>
                                                    {this.state.new_feature.attached_files.map(
                                                        (e) => {
                                                            return (
                                                                <Link
                                                                    to={`/pdf-viewer/file_manager/help_documents/${e.file_id}`}
                                                                >
                                                                    <ListItem>
                                                                        <ListItemText
                                                                            primary={
                                                                                e.file
                                                                            }
                                                                        />
                                                                    </ListItem>
                                                                </Link>
                                                            );
                                                        }
                                                    )}
                                                </List>
                                            )}
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.handleCloseViewGroupModal}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    <div>
                        <Modal
                            isOpen={this.state.editFeatureModal}
                            className={classes.addUserModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    PROWORK USE ONLY
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <p
                                        style={{
                                            color: "white",
                                            backgroundColor: "#61b4ff",
                                            fontWeight: "bold",
                                            textAlign: "center",
                                        }}
                                    >
                                        PROWORK USE ONLY
                                    </p>
                                    <hr />
                                    <ModalRow>
                                        <Col>
                                            <Label for="status">
                                                Status:&nbsp;&nbsp;
                                            </Label>

                                            <Select
                                                id="status"
                                                value={
                                                    this.state.new_feature
                                                        .feature_status
                                                }
                                                style={{ width: "190px" }}
                                                onChange={(event) => {
                                                    let newFeature = this.state
                                                        .new_feature;
                                                    newFeature.feature_status =
                                                        event.target.value;
                                                    this.setState({
                                                        new_feature: newFeature,
                                                    });
                                                }}
                                            >
                                                <MenuItem value="InProgress">
                                                    InProgress
                                                </MenuItem>
                                                <MenuItem value="Pending">
                                                    Pending
                                                </MenuItem>
                                                <MenuItem value="Done">
                                                    Done
                                                </MenuItem>
                                            </Select>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="build">
                                                Build Number
                                            </Label>

                                            <Input
                                                id="build"
                                                value={
                                                    this.state.new_feature
                                                        .feature_build_number
                                                }
                                                placeholder="Build Number"
                                                onChange={(event) => {
                                                    let newFeature = this.state
                                                        .new_feature;
                                                    newFeature.feature_build_number =
                                                        event.target.value;
                                                    this.setState({
                                                        new_feature: newFeature,
                                                    });
                                                }}
                                            />
                                        </Col>
                                        <Col>
                                            <Label for="jira">
                                                Jira Number
                                            </Label>
                                            <Input
                                                id="jira"
                                                value={
                                                    this.state.new_feature
                                                        .feature_jira_number
                                                }
                                                placeholder="Jira Number"
                                                onChange={(event) => {
                                                    let newFeature = this.state
                                                        .new_feature;
                                                    newFeature.feature_jira_number =
                                                        event.target.value;
                                                    this.setState({
                                                        new_feature: newFeature,
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="DOR">
                                                Date of Resolution
                                            </Label>
                                            <div>
                                                <TextField
                                                    id="datetime-local"
                                                    type="datetime-local"
                                                    defaultValue="2020-07-03T15:30"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    onChange={(event) => {
                                                        let newFeature = this
                                                            .state.new_feature;
                                                        newFeature.feature_resolution_time =
                                                            event.target.value;
                                                        this.setState({
                                                            new_feature: newFeature,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">Comments</Label>
                                            <div>
                                                <textarea
                                                    id="name"
                                                    multiline={false}
                                                    style={{
                                                        height: "133px",
                                                        width:
                                                            "-webkit-fill-available",
                                                    }}
                                                    value={
                                                        this.state.new_feature
                                                            .feature_comments
                                                    }
                                                    placeholder="Comments"
                                                    onChange={(event) => {
                                                        let newFeature = this
                                                            .state.new_feature;
                                                        newFeature.feature_comments =
                                                            event.target.value;
                                                        this.setState({
                                                            new_feature: newFeature,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={this.handleCloseEditGroupModal}
                                        className={classes.backButton}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.props.editFeature(new_feature);
                                            this.handleCloseEditGroupModal();
                                        }}
                                    >
                                        Update
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    <div>
                        <Modal
                            isOpen={this.state.newFeatureModal}
                            className={classes.addUserModal}
                        >
                            <StyledHeader>
                                <center>
                                    <Typography
                                        variant="h5"
                                        style={{
                                            color: "#6a7bc4",
                                        }}
                                    >
                                        Request New Feature
                                    </Typography>
                                </center>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label
                                                for="name"
                                                style={{ color: "#6a7bc4" }}
                                            >
                                                <b> Company Name </b>
                                            </Label>
                                            <div>
                                                <Input
                                                    id="name"
                                                    multiline={false}
                                                    style={{
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "9px",
                                                        width: "420px",
                                                    }}
                                                    value={
                                                        this.state.new_feature
                                                            .feature_name
                                                    }
                                                    placeholder="Company Name"
                                                    onChange={(event) => {
                                                        let newFeature = this
                                                            .state.new_feature;

                                                        newFeature.feature_name =
                                                            event.target.value;
                                                        this.setState({
                                                            new_feature: newFeature,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </ModalRow>
                                    {/* <br /> */}

                                    <ModalRow>
                                        <Col>
                                            <Label style={{ color: "#6a7bc4" }}>
                                                <b> Type Of Request </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>

                                    <ModalRow>
                                        <Col>
                                            {/* <Label for="name">
                                                Company Name&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <TextField
                                                id="name"
                                                multiline={false}
                                                style={{ width: "150px" }}
                                                value={
                                                    this.state.new_feature
                                                        .feature_name
                                                }
                                                placeholder="Company Name"
                                                onChange={(event) => {
                                            
                                                    let newFeature = this.state
                                                        .new_feature;
                                                    newFeature.feature_name =
                                                        event.target.value;
                                                    this.setState({
                                                        new_feature: newFeature,
                                                    });

                                                }}
                                            />*/}
                                            <RadioGroup
                                                row
                                                aria-label="position"
                                                name="feature_type"
                                                defaultValue="top"
                                                value={
                                                    this.state.new_feature
                                                        .feature_type
                                                }
                                                onChange={(event) => {
                                                    let newFeature = this.state
                                                        .new_feature;
                                                    newFeature.feature_type =
                                                        event.target.value;
                                                    this.setState({
                                                        new_feature: newFeature,
                                                    });
                                                }}
                                            >
                                                <FormControlLabel
                                                    value="New Report"
                                                    control={
                                                        <Radio
                                                            style={{
                                                                color:
                                                                    "#FF00FF",
                                                            }}
                                                        />
                                                    }
                                                />
                                                <RadioLabel
                                                    style={{
                                                        color: "#FF00FF",
                                                        width: "100px",
                                                    }}
                                                >
                                                    New Report
                                                </RadioLabel>

                                                <FormControlLabel
                                                    value="BUG / Crash"
                                                    control={
                                                        <Radio
                                                            style={{
                                                                color:
                                                                    "#FF0000",
                                                            }}
                                                        />
                                                    }
                                                />
                                                <RadioLabel
                                                    style={{
                                                        color: "#FF0000",
                                                        width: "100px",
                                                    }}
                                                >
                                                    Bug / Crash
                                                </RadioLabel>

                                                <FormControlLabel
                                                    value="Enhancement"
                                                    control={
                                                        <Radio
                                                            style={{
                                                                color:
                                                                    "#4C9900",
                                                            }}
                                                        />
                                                    }
                                                />
                                                <RadioLabel
                                                    style={{
                                                        color: "#4C9900",
                                                        width: "100px",
                                                    }}
                                                >
                                                    Enhancement
                                                </RadioLabel>

                                                <FormControlLabel
                                                    value="Video Tutorial"
                                                    control={
                                                        <Radio
                                                            style={{
                                                                color:
                                                                    "#3399FF",
                                                            }}
                                                        />
                                                    }
                                                />
                                                <RadioLabel
                                                    style={{
                                                        color: "#3399FF",
                                                        width: "100px",
                                                    }}
                                                >
                                                    Video Tutorial
                                                </RadioLabel>

                                                <FormControlLabel
                                                    value="Other"
                                                    control={
                                                        <Radio
                                                            style={{
                                                                color:
                                                                    "#FF9933",
                                                            }}
                                                        />
                                                    }
                                                />
                                                <RadioLabel
                                                    style={{
                                                        color: "#FF9933",
                                                        width: "100px",
                                                    }}
                                                >
                                                    Other
                                                </RadioLabel>
                                            </RadioGroup>
                                        </Col>
                                    </ModalRow>

                                    <ModalRow>
                                        {this.state.new_feature.feature_type ===
                                        "Other" ? (
                                            <Col>
                                                <Label
                                                    style={{ color: "#6a7bc4" }}
                                                >
                                                    <b> Request Details </b>
                                                </Label>
                                                <div>
                                                    <Input
                                                        id="other"
                                                        multiline={false}
                                                        style={{
                                                            border:
                                                                "2px solid #0188cc",
                                                            borderRadius: "9px",
                                                            width: "420px",
                                                        }}
                                                        value={
                                                            this.state
                                                                .new_feature
                                                                .feature_other
                                                        }
                                                        placeholder="Other Type Of Request Details"
                                                        onChange={(event) => {
                                                            let newFeature = this
                                                                .state
                                                                .new_feature;
                                                            newFeature.feature_other =
                                                                event.target.value;
                                                            this.setState({
                                                                new_feature: newFeature,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        ) : (
                                            ""
                                        )}
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label
                                                style={{ color: "#6a7bc4" }}
                                                for="platform"
                                            >
                                                <b> Platform </b>
                                            </Label>
                                            <div>
                                                <Select
                                                    id="platform"
                                                    style={{
                                                        width: "420px",
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "9px",
                                                    }}
                                                    value={
                                                        this.state.new_feature
                                                            .feature_platform
                                                    }
                                                    onChange={(event) => {
                                                        let newFeature = this
                                                            .state.new_feature;
                                                        newFeature.feature_platform =
                                                            event.target.value;
                                                        this.setState({
                                                            new_feature: newFeature,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="App">
                                                        App
                                                    </MenuItem>
                                                    <MenuItem value="Dashboard">
                                                        Dashboard
                                                    </MenuItem>
                                                    <MenuItem value="App and Dashboard">
                                                        App and Dashboard
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                        </Col>
                                    </ModalRow>

                                    <ModalRow>
                                        <Col>
                                            <Label
                                                style={{ color: "#6a7bc4" }}
                                                for="impacted-pages"
                                            >
                                                <b>Impacted Page </b>
                                            </Label>
                                            <div>
                                                <Input
                                                    id="impacted-pages"
                                                    multiline={false}
                                                    style={{
                                                        width: "420px",
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "9px",
                                                    }}
                                                    value={
                                                        this.state.new_feature
                                                            .feature_impacted_page
                                                    }
                                                    placeholder="Impacted Page"
                                                    onChange={(event) => {
                                                        let newFeature = this
                                                            .state.new_feature;
                                                        newFeature.feature_impacted_page =
                                                            event.target.value;
                                                        this.setState({
                                                            new_feature: newFeature,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </ModalRow>

                                    <ModalRow>
                                        <center>
                                            <p style={{ color: "red" }}>
                                                Note: High Priorityis only
                                                selected when you are blocked
                                                from working!
                                            </p>
                                        </center>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label
                                                style={{ color: "#6a7bc4" }}
                                                for="priority"
                                            >
                                                <b> Priority </b>
                                            </Label>
                                            <div>
                                                <Select
                                                    id="priority"
                                                    value={
                                                        this.state.new_feature
                                                            .feature_priority
                                                    }
                                                    style={{
                                                        width: "420px",
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "9px",
                                                    }}
                                                    onChange={(event) => {
                                                        let newFeature = this
                                                            .state.new_feature;
                                                        newFeature.feature_priority =
                                                            event.target.value;
                                                        this.setState({
                                                            new_feature: newFeature,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value="Low">
                                                        Low
                                                    </MenuItem>
                                                    <MenuItem value="Medium">
                                                        Medium
                                                    </MenuItem>
                                                    <MenuItem value="High">
                                                        High
                                                    </MenuItem>
                                                </Select>
                                            </div>
                                        </Col>
                                    </ModalRow>

                                    <ModalRow>
                                        <Col>
                                            <Label
                                                for="description"
                                                style={{ color: "#6a7bc4" }}
                                            >
                                                <b>
                                                    {" "}
                                                    Feature Request Description{" "}
                                                </b>
                                            </Label>
                                            <div>
                                                <TextareaAutosize
                                                    id="description"
                                                    rowsMin={5}
                                                    multiline={false}
                                                    style={{
                                                        width: "420px",
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "9px",
                                                    }}
                                                    value={
                                                        this.state.new_feature
                                                            .feature_description
                                                    }
                                                    placeholder="Feature Description"
                                                    onChange={(event) => {
                                                        let newFeature = this
                                                            .state.new_feature;
                                                        newFeature.feature_description =
                                                            event.target.value;
                                                        this.setState({
                                                            new_feature: newFeature,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label style={{ color: "#6a7bc4" }}>
                                                <b> Requester Details </b>
                                            </Label>
                                        </Col>
                                    </ModalRow>

                                    <ModalRow>
                                        <Col>
                                            <Label
                                                for="requestor-name"
                                                style={{ color: "#6a7bc4" }}
                                            >
                                                <b> Requester Name </b>
                                            </Label>

                                            <Input
                                                id="requestor-name"
                                                multiline={false}
                                                style={{
                                                    width: "190px",
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                }}
                                                value={
                                                    this.state.new_feature
                                                        .feature_requestor_name
                                                }
                                                placeholder="Requester Name"
                                                onChange={(event) => {
                                                    let newFeature = this.state
                                                        .new_feature;
                                                    newFeature.feature_requestor_name =
                                                        event.target.value;
                                                    this.setState({
                                                        new_feature: newFeature,
                                                    });
                                                }}
                                            />
                                        </Col>
                                        <Col>
                                            <Label
                                                for="requestor-email"
                                                style={{ color: "#6a7bc4" }}
                                            >
                                                <b> Requester Email </b>
                                            </Label>
                                            <Input
                                                id="requestor-email"
                                                multiline={false}
                                                style={{
                                                    width: "190px",
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                }}
                                                value={
                                                    this.state.new_feature
                                                        .feature_requestor_email
                                                }
                                                placeholder="Requester Email"
                                                onChange={(event) => {
                                                    let newFeature = this.state
                                                        .new_feature;
                                                    newFeature.feature_requestor_email =
                                                        event.target.value;
                                                    this.setState({
                                                        new_feature: newFeature,
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>

                                    <ModalRow>
                                        {/* <Col>
                                            <Label for="requestor-organization" style={{color:"#6a7bc4"}}>
                                            <b>  Organization </b>
                                            </Label>
                                            <div>
                                                <Input
                                                    id="requestor-organization"
                                                    multiline={false}
                                                    style={{ width: "190px",border: "2px solid #0188cc",
                                                    borderRadius: "9px" }}
                                                    value={
                                                        this.state.new_feature
                                                            .feature_requestor_organization
                                                    }
                                                    placeholder="Organization"
                                                    onChange={(event) => {
                                                        let newFeature = this.state
                                                            .new_feature;
                                                        newFeature.feature_requestor_organization =
                                                            event.target.value;
                                                        this.setState({
                                                            new_feature: newFeature,
                                                        });
                                                    }}
                                                />
                                            </div>
                                            </Col> */}

                                        <Col>
                                            <Label style={{ color: "#6a7bc4" }}>
                                                <b> Date of Request </b>
                                            </Label>
                                            <div>
                                                <TextField
                                                    id="datetime-local"
                                                    type="datetime-local"
                                                    style={{
                                                        width: "420px",
                                                        border:
                                                            "2px solid #0188cc",
                                                        borderRadius: "9px",
                                                    }}
                                                    defaultValue={currDate}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    onChange={(event) => {
                                                        // let dateObj = new Date(
                                                        //     event.target.value
                                                        // );
                                                        // var inputDate =
                                                        //     dateObj.getDate() +
                                                        //     "-" +
                                                        //     (dateObj.getMonth() +
                                                        //         1) +
                                                        //     "-" +
                                                        //     dateObj.getFullYear() +
                                                        //     " " +
                                                        //     dateObj.getHours() +
                                                        //     ":" +
                                                        //     dateObj.getMinutes();

                                                        let newFeature = this
                                                            .state.new_feature;
                                                        newFeature.feature_date = event.target.value;
                                                        this.setState({
                                                            new_feature: newFeature,
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </ModalRow>
                                    {this.renderRequiredGroupDetails()}

                                    <ModalRow>
                                        <center>
                                            <p style={{ color: "red" }}>
                                                Please allow upto 2 weeks for
                                                your changes to be applied
                                            </p>
                                        </center>
                                    </ModalRow>
                                    <ModalRow>
                                        <Label
                                            style={{
                                                color: "#6a7bc4",
                                                marginLeft: "17px",
                                            }}
                                        >
                                            {" "}
                                            <b> Add Documents</b>{" "}
                                        </Label>
                                        <input
                                            accept="application/pdf"
                                            type="file"
                                            multiple
                                            onChange={(event) => {
                                                let attached_files =
                                                    _.get(
                                                        new_feature,
                                                        "attached_files"
                                                    ) || [];

                                                Object.keys(
                                                    event.target.files
                                                ).map(async (file_index) => {
                                                    if (
                                                        event.target.files[
                                                            file_index
                                                        ].size < 10000000
                                                    )
                                                        await this.props.uploadFileManager(
                                                            event.target.files[
                                                                file_index
                                                            ],
                                                            "help_documents",
                                                            (status) => {},
                                                            (newFile) => {
                                                                attached_files = [
                                                                    ...attached_files,
                                                                    newFile,
                                                                ];
                                                                let fileData = this
                                                                    .state
                                                                    .new_feature;
                                                                fileData.attached_files = attached_files;
                                                                this.setState({
                                                                    new_feature: fileData,
                                                                });
                                                            }
                                                        );
                                                    else
                                                        this.setState({
                                                            maxSizeExceeded: true,
                                                        });
                                                    return true;
                                                });
                                            }}
                                            style={{
                                                display: "none",
                                            }}
                                            ref={(fileInput) =>
                                                (this.fileInput = fileInput)
                                            }
                                        />

                                        <Button
                                            fullWidth
                                            style={{
                                                width: "100%",
                                                display: "inline",
                                                backgroundColor: "#0188cc",
                                                color: "white",
                                            }}
                                            onClick={() => {
                                                this.fileInput.click();
                                            }}
                                            variant="contained"
                                        >
                                            + Upload File
                                        </Button>
                                    </ModalRow>
                                    <ModalRow>
                                        {this.state.new_feature
                                            .attached_files && (
                                            <List>
                                                {this.state.new_feature.attached_files.map(
                                                    (e) => {
                                                        return (
                                                            <ListItem>
                                                                <ListItemText
                                                                    primary={
                                                                        e.file
                                                                    }
                                                                />
                                                            </ListItem>
                                                        );
                                                    }
                                                )}
                                            </List>
                                        )}
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={this.handleCloseGroupModal}
                                        className={classes.backButton}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.setState({
                                                processModal: true,
                                            });
                                            this.props.emailFeature(
                                                new_feature,
                                                (success) => {
                                                    if (success === true) {
                                                        this.onFormSubmit(
                                                            new_feature
                                                        );
                                                    } else {
                                                        this.handleCloseGroupModal();
                                                    }
                                                }
                                            );
                                        }}
                                        disabled={
                                            this.state.new_feature
                                                .feature_name === ""
                                                ? true
                                                : false
                                        }
                                    >
                                        Add Feature
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    <div>
                        <Modal
                            isOpen={this.state.removeFeatureModal}
                            className={classes.addUserModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Remove Feature
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <Typography variant="body2">
                                        Are you you sure you want to remove this
                                        Feature? <br />
                                    </Typography>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={
                                            this.handleCloseRemoveGroupModal
                                        }
                                        className={classes.backButton}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.props.removeFeature(
                                                this.state.removeUID
                                            );
                                            this.handleCloseRemoveGroupModal();
                                        }}
                                    >
                                        Remove
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                </StyledContent>
            </StyledCard>
        );
    }
}

export default connect(
    (store) => {
        return {
            features: selectFeature(store),
            requesting: getRequesting(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
        };
    },
    {
        setNewFeature,
        getFeatures,
        removeFeature,
        emailFeature,
        editFeature,
        uploadFile,
        uploadFileManager,
    }
)(withStyles(styles)(Help));
